import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import classNames from 'classnames';
// import dateFormat from 'dateformat';

import { ajax } from 'svs-utils/web';
import { MainMenu } from 'svs-utils/react';

import { useStateSlice } from '../utils/reactUtils.js';
import FlightLogs from './flightLogs.js';
import './home.scss';

let menuItems = {
    flightlogs: { title: 'Flight Logs', shouldShow: () => true, content: () => <FlightLogs /> },
};

function Home(props) {
    let [dbInfo, setDbInfo] = useStateSlice('dbInfo');

    let urlParams = useParams();
    let navigate = useNavigate();

    useEffect(() => {
        let path = urlParams.homePath?.toLowerCase();

        if (!menuItems[path] || (!menuItems[path].shouldShow?.() && !menuItems[path].onlyDirect)) {
            navigate('/404');
            return;
        }

        if (!Object.keys(dbInfo.locations).length) {
            ajax({ endPoint: '/getDbTablesInfo' }).then((results) => {
                if (results.result) {
                    let { locations, wings, paramotors, engines } = results;
                    setDbInfo({ locations, wings, paramotors, engines });
                }
            });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    let homePath = urlParams.homePath?.toLowerCase();

    return (
        <div className='home'>
            <MainMenu menuItems={menuItems} title={menuItems[homePath]?.title} type='lightSolid' />
            <div className={classNames('homeContentContainer')}>
                <div className='homeContent'>
                    {menuItems[homePath]?.content()}
                </div>
            </div>
        </div>
    );
}

export default Home;
